import { render } from "./HomeSectionTwo.vue?vue&type=template&id=1622e09a&scoped=true"
import script from "./HomeSectionTwo.vue?vue&type=script&lang=js"
export * from "./HomeSectionTwo.vue?vue&type=script&lang=js"

import "./HomeSectionTwo.vue?vue&type=style&index=0&id=1622e09a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1622e09a"

export default script